export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/dThree.240f44b.svg";